import { render, staticRenderFns } from "./ImportFromFile.vue?vue&type=template&id=0805d916&scoped=true&"
import script from "./ImportFromFile.vue?vue&type=script&lang=js&"
export * from "./ImportFromFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805d916",
  null
  
)

export default component.exports